import { Component, output } from '@angular/core';

@Component({
  selector: 'app-error500',
  template: `
    <p class="alert alert-danger">
      Whoops, looks like something went wrong.
      <button type="button" class="close-icon" aria-label="Close" (click)="closed.emit()"><i class="fa fa-times"></i></button>
    </p>
  `,
  styleUrl: './error500.scss',
})
export class Error500 {
  readonly closed = output();
}
